import { computationOptions } from "#app/computationOptions";

type LayoutScrapBillingRates = {
  scrapMaterialBillingRate: number;
  newScrapMaterialBillingRate: number;
};

export const getLayoutScrapBillingRate = (layout: LayoutScrapBillingRates) =>
  computationOptions.isTrueShapeNestingEnabled
    ? layout.newScrapMaterialBillingRate
    : layout.scrapMaterialBillingRate;

export const toScrapBillingRatePayload = (rate: number) =>
  computationOptions.isTrueShapeNestingEnabled
    ? { newScrapMaterialBillingRate: rate }
    : { scrapMaterialBillingRate: rate };
